"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
// create a data store for previously calculated results
function memoized() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    var key = JSON.stringify(args);
    this._value = this._value || {};
    return this._value[key] !== undefined ? this._value[key] : this._value[key] = this.apply(this, arguments);
};

// returns a function whos calculated results will be memoized
function memoize(fn) {
    return function () {
        return memoized.apply(fn, arguments);
    };
};

exports.default = memoize;